import React, { useState, useEffect } from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { mtDividerUpTable } from '../../../commons';
import { hasPemissions } from '../../../commons/utils';
import { BreadCrumbsAndTitle } from '../../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../../components/generics/AlertsInformativos';
import { SnackAlert } from '../../../components/SnackAlert';

import { TableAusenciaEmpleado } from './TableAusenciaEmpleado';
import { CreateAusenciaEmpleadoModal } from './modals/CreateAusenciaEmpleadoModal';
import { EditAusenciaEmpleadoModal } from './modals/EditAusenciaEmpleadoModal';
import { BannerInfoAusenciaEmpleado } from './components/BannerInfoAusenciaEmpleado';

export const AusenciaEmpleado = () => {
    const [openCreate, setOpenCreate] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [itemToEdit, setItemToEdit] = useState<any>(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [canCreate, setCanCreate] = useState<boolean>(false);

    useEffect(() => {
        checkPermissions();
    }, []);

    const checkPermissions = async () => {
        const create = await hasPemissions('modulo.thumano', 'modulo.empleado.ausencias', 'create');
        if (create) setCanCreate(true);
    };

    const handleOpenCreate = () => setOpenCreate(true);
    
    const handleEdit = (absence: any) => {
        setItemToEdit(absence);
        setOpenEdit(true);
    };

    const handleView = (absence: any) => {
        // Implement view functionality if needed (or reuse Edit in view mode)
        setItemToEdit(absence);
        setOpenEdit(true);
    };

    const handleSuccessAction = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <Box sx={{ p: { xs: 2, md: 3 }, margin: '0 auto' }}>
            <SnackAlert />
            
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box>
                    <BreadCrumbsAndTitle 
                        title="Ausencias de Empleados"
                        mainModule="Talento Humano"
                        parent=""
                        action=""
                        icon="EventBusy"
                    />
                    
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        <AlertsInformativos type={'info'} title={'info'} content="Gestión de ausencias (vacaciones, incapacidades, permisos). Los registros creados aquí se aprueban automáticamente." /> 
                    </Typography>
                </Box>

                {canCreate && (
                    <Button 
                        variant="contained" 
                        color="primary" 
                        startIcon={<AddIcon />} 
                        onClick={handleOpenCreate}
                        sx={{
                            borderRadius: 2,
                            px: 3,
                            py: 1,
                            fontWeight: 600,
                            textTransform: 'none',
                            boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)'
                        }}
                    >
                        Registrar Ausencia
                    </Button>
                )}
            </Box>

            <Divider sx={{ marginBottom: mtDividerUpTable }} />

            <TableAusenciaEmpleado 
                onEdit={handleEdit} 
                onView={handleView}
                refreshDataTrigger={refreshTrigger}
            />

            <BannerInfoAusenciaEmpleado/>

            <CreateAusenciaEmpleadoModal 
                open={openCreate} 
                setOpen={setOpenCreate} 
                onSuccess={handleSuccessAction} 
            />

            {itemToEdit && (
                <EditAusenciaEmpleadoModal 
                    open={openEdit} 
                    setOpen={setOpenEdit} 
                    onSuccess={handleSuccessAction} 
                    itemToEdit={itemToEdit}
                />
            )}
        </Box>
    );
};
